


export const FETCH_INTERVALS = 'FETCH_INTERVALS'
export const FETCH_SEASONS =' FETCH_SEASONS'
export const INTERVAL_ERROR = 'INTERVAL_ERROR'
export const SELECT_INTERVAL = 'SELECT_INTERVAL'



// WEBPACK FOOTER //
// ./src/interval/types.js